module.exports = __webpack_public_path__ + "img/inserter-3.73ef4c4a.png";